module.exports = __webpack_public_path__ + "static/media/list-ul.8fae4ac4.svg";